import { createAsyncThunk } from '@reduxjs/toolkit';
import { verifyCode } from 'services/pod';
import { IVerifyCodePayload } from 'services/pod/types';

export const ThunkVerifyCode = createAsyncThunk<boolean, IVerifyCodePayload>(
  'pod/verifyCode',
  async payload => {
    const r = await verifyCode(payload).then(r => r.data);

    return r;
  },
);
